import { render, staticRenderFns } from "./TestRegisterComp.vue?vue&type=template&id=194c7807&scoped=true&"
import script from "./TestRegisterComp.vue?vue&type=script&lang=tsx&"
export * from "./TestRegisterComp.vue?vue&type=script&lang=tsx&"
import style0 from "./TestRegisterComp.vue?vue&type=style&index=0&id=194c7807&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c7807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194c7807')) {
      api.createRecord('194c7807', component.options)
    } else {
      api.reload('194c7807', component.options)
    }
    module.hot.accept("./TestRegisterComp.vue?vue&type=template&id=194c7807&scoped=true&", function () {
      api.rerender('194c7807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingTestPages/TestRegisterComp.vue"
export default component.exports